import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface GlobalSlice {
  // responsivePoint: "xxl" | "xl" | "lg" | "md" | "sm" | "xs";
  // showNav: boolean;
  // isMD: boolean;
  isLogin: boolean;
  logPath: string;
  user: undefined | string;
  stateCid: string;
  level: string;
  loginCid: string;
  gid: string[];
  // scheme: any;
  // dashboardSetting: {
  //   PieHealth: boolean;
  //   PieSignal: boolean;
  //   PieModel: boolean;
  //   PieFirmware: boolean;
  // PiePeriod: boolean;
  // PiePeriodUpdate: boolean;
  // Router: boolean;
  // IoT: boolean;
  //   Map: boolean;
  // };
  isDarkMode: boolean;
  time_zone: string;
}

// const user = localStorage.getItem("authUser.name");
// const cid = localStorage.getItem("authUser.cid") || "";
// const level = localStorage.getItem("authUser.level") || "";

const initialState: GlobalSlice = {
  // showNav: true,
  // isMD: false,
  // responsivePoint: "xs",
  isLogin: localStorage.getItem("authUser.name") ? true : false,
  logPath: "/",
  user: localStorage.getItem("authUser.name") || undefined,
  stateCid: "",
  level: localStorage.getItem("authUser.level") || "",
  loginCid: localStorage.getItem("authUser.cid") || "",
  gid: [],
  // dashboardSetting: {
  // PieHealth: true,
  // PieSignal: true,
  // PieModel: true,
  // PieFirmware: true,
  // PiePeriod: true,
  // PiePeriodUpdate: true,
  // Router: false,
  // IoT: false,
  // Map: true,
  // },
  isDarkMode: false,
  time_zone: "Asia/Taipei",
};

const globalSlice = createSlice({
  name: "global",
  initialState,
  reducers: {
    // setShowNav: (state, action: PayloadAction<boolean>) => {
    //   state.showNav = action.payload;
    // },
    // setIsMD: (state, action: PayloadAction<boolean>) => {
    //   state.isMD = action.payload;
    // },

    setIsLogin: (state, action: PayloadAction<boolean>) => {
      state.isLogin = action.payload;
    },
    setLogPath: (state, action: PayloadAction<string>) => {
      state.logPath = action.payload;
    },
    setUser: (state, action: PayloadAction<string | undefined>) => {
      state.user = action.payload;
    },
    setStateCid: (state, action: PayloadAction<string>) => {
      state.stateCid = action.payload;
    },
    setLevel: (state, action: PayloadAction<string>) => {
      state.level = action.payload;
    },
    setLoginCid: (state, action: PayloadAction<string>) => {
      state.loginCid = action.payload;
    },
    // setDashboardSetting: (state, action: PayloadAction<any>) => {
    //   state.dashboardSetting = action.payload;
    // },
    setIsDarkMode: (state, action: PayloadAction<boolean>) => {
      state.isDarkMode = action.payload;
    },
    setTimeZone: (state, action: PayloadAction<string>) => {
      state.time_zone = action.payload;
    },
    setGid: (state, action: PayloadAction<string[]>) => {
      state.gid = action.payload;
    },
    // setResponsivePoint: (state, action: PayloadAction<GlobalSlice["responsivePoint"]>) => {
    //   state.responsivePoint = action.payload;
    // },
  },
});

export const {
  // setShowNav,
  setIsLogin,
  setLogPath,
  setUser,
  setStateCid,
  setLevel,
  setLoginCid,
  // setDashboardSetting,
  setIsDarkMode,
  setTimeZone,
  setGid,
  // setIsMD,
  // setResponsivePoint,
} = globalSlice.actions;

export default globalSlice;
